import { useCallback, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { message, Row, Col } from 'antd'
import { PageHeader } from '../../Common'
import { toPath } from '../../../routes'

import usePracticeCycles from '../../Common/usePracticeCycles'

import { fileToDataUrl } from '../../../lib/file'
import PDFPreview from '../../Common/PDFPreview'

import PatientForm from './PatientForm'
import CreateTranssmision from './UseCase/Results'
import ReportUpload from './ReportUpload'

export default function Upload() {
  const navigate = useNavigate()

  const [patient, setPatient] = useState()
  const [pdfUrl, setPdfUrl] = useState()
  const [file, setFile] = useState()
  const { practiceId } = useParams()
  // eslint-disable-next-line no-unused-vars
  const [_, { practice }] = usePracticeCycles()

  const onSubmit = useCallback(
    async (payload, { setErrors }) => {
      const {
        patientId,
        firstName,
        lastName,
        dateOfBirth,
        practiceMrn,
        deviceModelId,
        deviceSerialNumber,
        dateOfCheck,
        transmissionDate,
      } = payload
      const showErrors = errors =>
        typeof errors === 'string' ? message.error(errors) : setErrors(errors)

      try {
        const [patientCreationResult, createUploadResult] =
          await CreateTranssmision(
            patient?.id || patientId,
            practiceId,
            patient,
            {
              firstName,
              lastName,
              dateOfBirth,
              practiceMrn,
              deviceModelId,
              deviceSerialNumber,
              dateOfCheck,
              transmissionDate,
            },
            file,
          )
        if (
          patientCreationResult.isSuccess() &&
          createUploadResult.isSuccess()
        ) {
          setPatient(undefined)

          message.success('Transmission successfully created')
          navigate(toPath.transmissions())

          return
        }

        if (!createUploadResult.isSuccess()) {
          message.error(createUploadResult.getErrorMessage())
          return
        }

        if (!patientCreationResult.isSuccess()) {
          showErrors(patientCreationResult.getErrors())
        }
      } catch (e) {
        message.error(`Something went wrong. ${e.message}`)
        throw e
      }
    },
    [patient, practiceId, file, navigate],
  )

  const onReportUpload = async payload => {
    const pdf = payload.find(blob => blob.name.toLowerCase().endsWith('.pdf'))

    if (!pdf) {
      message.error('Please upload a PDF file')
      return
    }

    let previewUrl = null
    if (pdf) previewUrl = await fileToDataUrl(pdf)
    setFile(pdf)
    setPdfUrl(previewUrl)
  }

  return (
    <div>
      <PageHeader title="Add Transsmision" subTitle={practice?.name} />
      <Row gutter={{ sm: 12 }}>
        <Col span={12}>
          {!pdfUrl && <ReportUpload onUpload={onReportUpload} />}
          {pdfUrl && <PDFPreview url={pdfUrl} perPage={1} hidePagination />}
        </Col>
        <Col span={12}>
          <PatientForm practiceId={practiceId} onSubmit={onSubmit} />
        </Col>
      </Row>
    </div>
  )
}
